import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
    OFFER_TYPE_URL_PARAM,
    OFFER_TYPE_ONLINE,
    OFFER_TYPE_EBON,
    OFFER_TYPE_COUPON,
    OFFER_TYPE_BILLETTERIE,
    CASHBACK_SORT,
    CASHBACK_OFFLINE_SORT,
    CASHBACK_EBON_SORT,
    NBCOUPON_SORT
} from '../../../../services/directory/constants';

import { getQueryParams, buildQueryString } from '../../../../utils/routeUtils';

/**
 * Filtre par type d'offre de l'annuaire mixte. La valeur vit dans l'url
 * (?offre=...) comme le tri : elle survit donc aux changements de catégorie
 * et de lettre, qui propagent la query string.
 */
class OfferTypeSelectComponent extends React.Component {
    onChange = e => {
        const { history, location } = this.props;
        const params = getQueryParams(location.search);

        if (e.target.value) {
            params[OFFER_TYPE_URL_PARAM] = e.target.value;
        } else {
            delete params[OFFER_TYPE_URL_PARAM];
        }

        // Le tri courant peut ne pas exister dans la variante cible du select
        // de tri (ex. "Meilleur taux" n'existe pas en mode code promo, et
        // "Nombre de codes" n'existe qu'en code promo) : on retire alors le
        // paramètre pour retomber sur le tri par défaut (Les + populaires),
        // sinon le select afficherait un tri différent de celui appliqué.
        const sort = Number(params.sort);
        const invalidSort =
            e.target.value === OFFER_TYPE_COUPON
                ? [CASHBACK_SORT.id, CASHBACK_OFFLINE_SORT.id, CASHBACK_EBON_SORT.id].includes(sort)
                : sort === NBCOUPON_SORT.id;

        if (invalidSort) {
            delete params.sort;
        }

        history.push({
            pathname: location.pathname,
            search: buildQueryString(params)
        });
    };

    render() {
        const { i18n, location } = this.props;
        const value = getQueryParams(location.search)[OFFER_TYPE_URL_PARAM] || '';

        return (
            <div id="annuaire-types-offre-container" className="flex-container-h flex-center-alt">
                <div id="annuaire-types-offre" className="select">
                    {/* aria-label : pas de label visible, le select doit garder
                        un nom accessible (RGAA 11.1) */}
                    <select
                        id="annuaire-types-offre-select"
                        value={value}
                        onChange={this.onChange}
                        aria-label={i18n.LABEL}
                    >
                        <option value="">{i18n.ALL}</option>
                        <option value={OFFER_TYPE_ONLINE}>{i18n.ONLINE}</option>
                        <option value={OFFER_TYPE_EBON}>{i18n.EBON}</option>
                        <option value={OFFER_TYPE_BILLETTERIE}>{i18n.BILLETTERIE}</option>
                        <option value={OFFER_TYPE_COUPON}>{i18n.COUPON}</option>
                    </select>
                </div>
            </div>
        );
    }
}

OfferTypeSelectComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    i18n: state.i18n.page.DIRECTORY.OFFER_TYPES
});

export default withRouter(connect(mapStateToProps)(OfferTypeSelectComponent));



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/OfferTypeSelectComponent.js